var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.221 2.193c.079-.078.05-.235-.054-.34l-1.02-1.02c-.109-.109-.258-.136-.34-.054L.779 11.807c-.079.078-.05.235.054.34l1.02 1.02c.109.109.258.136.34.054L13.221 2.193z","key":0}),React.createElement("path",{"d":"M2.193.779c-.078-.079-.235-.05-.34.054l-1.02 1.02c-.109.109-.136.258-.054.34l11.028 11.028c.078.079.235.05.34-.054l1.02-1.02c.109-.109.136-.258.054-.34L2.193.779z","key":1})]);
}

Close.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Close;

Close.default = Close;
